import React, { useState, useEffect, useContext } from "react";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import AximDropdown from "components/Dropdown/AximDropdown";
import CurrencyFormatter from "components/Formatter/CurrencyFormatter";
import { Box } from "@mui/material";
import { apiGet } from "app/Services/ApiService";
import { employeeApiUrls } from "common/ApiUrls";
import LoaderAnimation from "pages/LoaderAnimation";

import moment from "moment";

export default function Benefits() {
    const { insuredId } = useContext(PrivateRoutesContext);

    const [benefitPeriodsDropdown, setBenefitPeriodsDropdown] = useState(null);
    const [benefitPeriodSelected, setBenefitPeriodSelected] = useState("");
    const [benefit, setBenefits] = useState(null);
    const [hasInitializationError, setHasInitializationError] = useState(false);
    const [hasLoadingError, setHasLoadingError] = useState(false);

    useEffect(() => {
        apiGet(employeeApiUrls.getBenefitPeriods(insuredId)).then((response) => {
            console.log(response.data);

            setBenefitPeriodsDropdown(response.data);
            if (response.data.length > 0) {
                setBenefitPeriodSelected(response.data[0]);
            }
        })
        .catch(e => {
            console.log(e);
            setHasInitializationError(true);
        });
    },[insuredId])

    useEffect(() => {
        setBenefits(null);
        setHasLoadingError(false);
        if (benefitPeriodSelected !== "") {
            apiGet(employeeApiUrls.getBenefits(insuredId, benefitPeriodSelected)).then((response) => {
                console.log(response.data);
                setBenefits(response.data);
            })
            .catch(e => {
                console.log(e);
                setHasLoadingError(true);
            });
        }
    },[benefitPeriodSelected])

    return (
        <Box className="container-fluid">
            {hasInitializationError ? <h4>Error initializing Employee Benefits Page.</h4> :
            <>
                <Box className="d-flex justify-content-start">
                    {benefitPeriodsDropdown === null ? <LoaderAnimation /> :
                    benefitPeriodsDropdown.length > 0 ? (
                        <AximDropdown
                            label="Benefit Periods"
                            handleChange={(e) => setBenefitPeriodSelected(e.target.value)}
                            value={benefitPeriodSelected}
                            pairs={benefitPeriodsDropdown.map(benefitPeriod => ({ value: benefitPeriod, text: moment(benefitPeriod).format("MMMM DD, YYYY") }))} />
                        ) : (
                        ""
                        )}
                </Box>
                <Box className="row justify-content-center">
                    {hasLoadingError ? <h4>Error Loading Data.</h4> :
                     benefit === null ? <LoaderAnimation /> :
                        <>
                            <>
                                {benefit.medical === null ? null :
                                    <BenefitDetails type="Medical" benefit={benefit.medical}/>
                                }
                            </>
                            <>
                                {benefit.dental === null ? null :
                                    <BenefitDetails type="Dental" benefit={benefit.dental}/>
                                }
                                
                            </>
                            <>
                                {benefit.vision === null ? null :
                                    <BenefitDetails type="Vision" benefit={benefit.vision}/>
                                }
                            </>
                            <>
                                {benefit.otherBenefits === null || benefit.otherBenefits.length === 0 ? null :
                                    <Box className="col-12 col-md-5 mx-3 mb-3">
                                        <Box className="row">
                                            <Box className="col-12 border text-center" sx={{backgroundColor:'primary.veryLight'}}>
                                                <h5><strong>
                                                Other Benefits
                                                </strong></h5>
                                            </Box>
                                            {benefit.otherBenefits.map(b => 
                                                <>
                                                    <Box className="col-6 border">{b.benefitTypeName}</Box>
                                                    <Box className="col-6 border text-end"><CurrencyFormatter value={b.benefitAmount}/></Box>
                                                </>
                                            )}
                                        </Box>
                                    </Box>
                                }
                            </>
                        </>
                    }
                </Box>
                </>
            }
        </Box>
    )
}

function BenefitDetails(props) {
    return (
        <Box className="col-12 col-md-5 mx-3 mb-3">
            <Box className="row">
                <Box className="col-12 border text-center" sx={{backgroundColor:'primary.veryLight'}}>
                    <h5><strong>
                        {props.type}
                    </strong></h5>
                </Box>
                <Box className="col-6 border">Carrier</Box>
                <Box className="col-6 border text-end">{props.benefit.carrier}</Box>
                <Box className="col-6 border">Plan Type</Box>
                <Box className="col-6 border text-end">{props.benefit.planType}</Box>
                <Box className="col-6 border">Plan Selected</Box>
                <Box className="col-6 border text-end">{props.benefit.planSelected}</Box>
                <Box className="col-6 border">Coverage</Box>
                <Box className="col-6 border text-end">{props.benefit.coverage}</Box>
                <Box className="col-6 border">Total Cost Per Month</Box>
                <Box className="col-6 border text-end"><CurrencyFormatter value={props.benefit.totalCostPerMonth}/></Box>
                <Box className="col-6 border">Employer Contribution Per Month</Box>
                <Box className="col-6 border text-end"><CurrencyFormatter value={props.benefit.employerContributionPerMonth}/></Box>
                <Box className="col-6 border">Employee Net Cost Per Month</Box>
                <Box className="col-6 border text-end"><CurrencyFormatter value={props.benefit.employeeNetCostPerMonth}/></Box>
            </Box>
        </Box>
    )
}